import React, { useEffect, useState } from "react";
import { Input, Form, Row, Col, Statistic, Space, InputNumber, DatePicker, Select } from "antd";
import Styles from "./Styles";
import moment from "moment";
import { apiGetPath } from "../../api/api";

const { Option } = Select;

/* 한 Row에 2컬럼인 폼의 컬럼분할 비율 */
const responsiveColOption = {
  sm: 24,
  md: 11,
};

function PopServiceChange({ onFinish, children }) {
  const [form] = Form.useForm();
  const [subPeriod, setSubPeriod] = useState();
  const [startDt, setStartDt] = useState(moment(children.startDt));
  const [list, setList] = useState({ catCd: "", catNm: "", codeNm: "", devTp: "" });

  useEffect(() => {
    form.setFieldsValue({
      ...children,
      startDt: moment(children.startDt),
      endDt: moment(children.endDt),
      devTp: list.devTp,
    });
    setStartDt(moment(children.startDt).format("YYYY-MM-DD"));
    apiDeviceCall();
  }, [children]);

  // [SVC-0105014006] 신청서비스별 디바이스 조회
  const apiDeviceCall = async () => {
    // const response = await apiGetPath(`Device/service/CAT00010`);
    const response = await apiGetPath(`Device/service/${children.catCd}`);
    try {
      if (response.code === 0) {
        setList(response.data);
      } else if (response.code === 10) {
        setList({ catCd: "", catNm: "", codeNm: "", devTp: "" });
      }
    } catch (error) {}
  };

  const onchangeSubPeriod = (e) => {
    setSubPeriod(e);
  };

  useEffect(() => {
    form.setFieldsValue({
      // startDt: moment(startDt),
      endDt: moment(startDt).add(subPeriod, "months"),
    });
  }, [subPeriod]);

  const disabledDate = (current) => {
    return current < moment(startDt).endOf("day");
  };

  return (
    <Styles>
      <Form
        name='basic'
        className='frm-top-header label-w-150'
        autoComplete='off'
        id='ChangeForm'
        onFinish={onFinish}
        form={form}
        children={children}
      >
        <Form.Item label='서비스 요청 번호' name='svcReqId' hidden={true}>
          <Input />
        </Form.Item>
        <Form.Item label='사이트명(사업장)' name='siteNm' hidden={true}>
          <Input />
        </Form.Item>
        <Form.Item label='디바이스 타입' name='devTp' hidden={true}>
          <Input />
        </Form.Item>
        <Form.Item label=' ' className='top-header'>
          <Row justify='space-between'>
            <Col {...responsiveColOption}>변경전</Col>
            <Col {...responsiveColOption}>변경후</Col>
          </Row>
        </Form.Item>
        <Form.Item label='디바이스 수량'>
          <Row justify='space-between'>
            <Col {...responsiveColOption}>
              <Form.Item label='변경전' className='label-only-mob'>
                <Statistic
                  value={`
                  ${list.codeNm === null ? "" : list.codeNm} 
                  ${children.devNum === undefined ? "0" : children.devNum}`}
                  suffix='대'
                />
              </Form.Item>
            </Col>
            <Col {...responsiveColOption}>
              <Form.Item hidden={true} name='devTp'>
                <Input />
              </Form.Item>
              <Form.Item label='변경후' className='label-only-mob' name='devNum'>
                <Space>
                  {list.codeNm === null ? "" : list.codeNm} <Input type={"number"} style={{ width: 140 }} />대
                  {/*<InputNumber type={"number"} style={{width: 140}} />대*/}
                </Space>
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
        <Form.Item label='서비스 개시요청일'>
          <Row justify='space-between'>
            <Col {...responsiveColOption}>
              <Form.Item label='변경전' className='label-only-mob'>
                {moment(children.startDt).format("YYYY-MM-DD")}
              </Form.Item>
            </Col>
            <Col {...responsiveColOption}>
              <Form.Item name='startDt' label='변경후' className='label-only-mob'>
                <DatePicker
                  format={["YYYY-MM-DD", "YYYYMMDD", "YYYY.MM.DD"]}
                  onChange={(data) => setStartDt(data)}
                  allowClear={false}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
        <Form.Item label='구독기간(약정기간)'>
          <Row justify='space-between'>
            <Col {...responsiveColOption}>
              <Form.Item label='변경전' className='label-only-mob'>
                <Statistic value={children.subPeriod} suffix='개월' />
              </Form.Item>
            </Col>
            <Col {...responsiveColOption}>
              <Form.Item name='subPeriod' label='변경후' className='label-only-mob'>
                <Select onChange={onchangeSubPeriod} style={{ width: 132 }}>
                  <Option value={6}>6개월</Option>
                  <Option value={12}>12개월</Option>
                  <Option value={36}>36개월</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
        <Form.Item label='서비스 만료일'>
          <Row justify='space-between'>
            <Col {...responsiveColOption}>
              <Form.Item label='변경전' className='label-only-mob'>
                {moment(children.endDt).format("YYYY-MM-DD")}
              </Form.Item>
            </Col>
            <Col {...responsiveColOption}>
              <Form.Item name='endDt' label='변경후' className='label-only-mob'>
                <DatePicker
                  format={["YYYY-MM-DD", "YYYYMMDD", "YYYY.MM.DD"]}
                  allowClear={false}
                  disabledDate={disabledDate}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
        <Form.Item label='월 구독료'>
          <Row justify='space-between'>
            <Col {...responsiveColOption}>
              <Form.Item label='변경전' className='label-only-mob'>
                <Statistic value={children.subPay === null ? "0" : children.subPay} suffix='원' />
              </Form.Item>
            </Col>
            <Col {...responsiveColOption}>
              <Form.Item name='subPay' label='변경후' className='label-only-mob'>
                <Space>
                  {/*<InputNumber type={"number"} step={1000} style={{ width: 132 }} />원 (VAT별도)*/}
                  <Input type={"number"} style={{ width: 132 }} />원 (VAT별도)
                  {/*<Input type={"number"} control={false} style={{ width: 132 }} />원 (VAT별도)*/}
                </Space>
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </Styles>
  );
}

export default PopServiceChange;
